"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumPharmacy = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const PremiumPharmacy_web_styles_1 = require("./PremiumPharmacy.web.styles");
const atome_1 = require("../../../../atome");
const react_native_star_rating_widget_1 = __importDefault(require("react-native-star-rating-widget"));
const PremiumCheck_1 = require("../../../../atome/Icon/Icons/PremiumCheck");
const reducers_1 = require("../../../../../store/reducers");
const hooks_1 = require("../../../../../store/hooks");
const PremiumPharmacy = ({ navigation, pharmacy, setConfirmationModal, setChosenPharmacy, }) => {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [showDetails, setShowDetails] = (0, react_1.useState)(false);
    const disable = pharmacy.id === userInformation.patientPharmacyRelation?.id;
    const Details = () => (react_1.default.createElement(react_native_1.View, { key: pharmacy.id },
        react_1.default.createElement(atome_1.Text, { children: pharmacy.descriptionShort, style: [PremiumPharmacy_web_styles_1.styles.pharmacyDescription] }),
        react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_web_styles_1.styles.divider },
            react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_web_styles_1.styles.buttonRow },
                react_1.default.createElement(react_native_1.Pressable, { style: PremiumPharmacy_web_styles_1.styles.button, onPress: () => {
                        navigation.navigate('PharmacyDetails', {
                            chosenPharmacy: pharmacy,
                        });
                    }, disabled: false },
                    react_1.default.createElement(atome_1.Text, { style: [PremiumPharmacy_web_styles_1.styles.buttonText] }, "Details")),
                react_1.default.createElement(react_native_1.Pressable, { style: disable ? PremiumPharmacy_web_styles_1.styles.buttonGreenDisabled : PremiumPharmacy_web_styles_1.styles.buttonGreen, onPress: () => {
                        setConfirmationModal(true), setChosenPharmacy(pharmacy);
                    }, disabled: disable },
                    react_1.default.createElement(atome_1.Text, { style: [
                            disable
                                ? PremiumPharmacy_web_styles_1.styles.buttonTextGreenDisabled
                                : PremiumPharmacy_web_styles_1.styles.buttonTextGreen,
                        ] }, disable ? 'Ausgewählte Apotheke' : 'Apotheke Wählen'))))));
    return (react_1.default.createElement(react_native_1.View, { style: [PremiumPharmacy_web_styles_1.styles.rectanglePremium] },
        react_1.default.createElement(react_native_1.Pressable, { onPress: () => setShowDetails(!showDetails) },
            react_1.default.createElement(react_native_1.Image, { source: {
                    height: react_native_1.Platform.OS === 'web' ? 60 : 30,
                    width: react_native_1.Platform.OS === 'web' ? 250 : 100,
                    uri: 'data:image/jpg;base64,' + pharmacy.image,
                }, style: PremiumPharmacy_web_styles_1.styles.image })),
        showDetails ? react_1.default.createElement(Details, null) : react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_web_styles_1.styles.detailsLine }),
        react_1.default.createElement(react_native_1.View, { style: [PremiumPharmacy_web_styles_1.styles.ratingRow] },
            react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_web_styles_1.styles.positionLeft },
                react_1.default.createElement(atome_1.Text, { style: [PremiumPharmacy_web_styles_1.styles.offWhiteColor] },
                    react_1.default.createElement(PremiumCheck_1.PremiumCheck, { color: "#e3e3e3", styles: [{ marginRight: 10 }] }),
                    "Beliebte Apotheke")),
            react_1.default.createElement(react_native_1.View, { style: PremiumPharmacy_web_styles_1.styles.positionRight },
                react_1.default.createElement(react_native_star_rating_widget_1.default, { rating: pharmacy.rating, onChange: () => { }, starSize: 19, color: "#e3e3e3", starStyle: PremiumPharmacy_web_styles_1.styles.starStyles })))));
};
exports.PremiumPharmacy = PremiumPharmacy;
